import * as React from 'react'
import { styled, FontWeight, ThemeInterface, css } from '$utils/theme'
import { TextFontWeight } from '$utils/theme/font'
import {
  VerticalMarginProps,
  verticalMarginsCss,
  alignmentCss,
  AlignmentProps,
  HorizontalMarginProps,
  horizontalMarginsCss,
} from '$utils/theme/css'

interface Props {
  className?: string
  as?: 'p' | 'li' | 'span'
  cooper?: boolean
  homeHeader?: boolean
  titleHome?: boolean
  header?: boolean
  title?: boolean
  subheader?: boolean
  menu?: boolean
  tiny?: boolean
  caption?: boolean
  weight?: TextFontWeight
  theme?: ThemeInterface
  uppercase?: boolean
  capitalize?: boolean
  centered?: boolean
  color?: string
  italic?: boolean
  wordBreak?: boolean
  lineThrough?: boolean
}

const TextRaw: React.SFC<Props & VerticalMarginProps & HorizontalMarginProps & AlignmentProps> = ({
  as: As = 'p',
  className,
  children,
}) => <As className={className}>{children}</As>

export const Text = styled(TextRaw)`
  color: ${p => (p.color ? p.theme.colors[p.color] : p.theme.colors.darkGrey)};
  ${alignmentCss};
  ${horizontalMarginsCss};
  ${verticalMarginsCss};
  ${p => p.uppercase && `text-transform: uppercase;`};
  ${p => p.capitalize && `text-transform: capitalize;`};
  ${p => p.lineThrough && `text-decoration: line-through;`};
  ${p => p.centered && `text-align:center`};
  ${p => p.homeHeader && p.theme.font.h1(FontWeight.light)};
  ${p => p.titleHome && p.theme.font.titleHome(FontWeight.light)};
  ${p => p.header && p.theme.font.h2(FontWeight.medium)};
  ${p => p.title && p.theme.font.h3(FontWeight.medium)};
  ${p => p.subheader && p.theme.font.large(FontWeight.medium)};
  ${p => p.menu && p.theme.font.small(FontWeight.regular)};
  ${p => p.tiny && p.theme.font.tiny(FontWeight.regular)};
  ${p => p.caption && p.theme.font.small(FontWeight.medium)};
  ${p => p.wordBreak && 'word-break: break-all;'}
  ${p =>
    !p.homeHeader &&
    !p.titleHome &&
    !p.header &&
    !p.title &&
    !p.subheader &&
    !p.menu &&
    !p.tiny &&
    !p.caption &&
    p.theme.font.base(p.weight || p.theme.fontWeight.regular)};
  ${p =>
    p.italic &&
    css`
      font-style: italic;
    `};
  ${p =>
    p.cooper &&
    css`
      font-family: 'Cooper', sans-serif !important;
    `};
  ${p =>
    p.weight &&
    css`
      font-weight: ${FontWeight[p.weight]} !important;
    `};
  ${p => p.header && `line-height: 1.2 !important;`}
  ${p => p.menu && `line-height: 1.4 !important;`}
  ${p => p.theme.media.onlyMobile`
    ${p.homeHeader && `line-height: 1.1;`}
    ${p.title && `line-height: 2rem;`}
    ${p.titleHome && `line-height: 2.8rem;`}
  `};
  ${p => p.theme.media.desktop`
    ${p.homeHeader && `line-height: 1.1;`}
    ${p.title && `line-height: 2rem;`}
    ${p.titleHome && `line-height: 2.8rem;`}
  `};
`



// WEBPACK FOOTER //
// ./src/views/components/Text/Text.tsx